<div class="w-full p-4">
    <div class="w-full flex justify-between items-center">
        <nz-radio-group
            [(ngModel)]="activitySourceFilter"
            nzButtonStyle="solid"
            nzSize="small"
        >
            <label nz-radio-button nzValue="all">All</label>
            <label nz-radio-button nzValue="workflow">Workflow</label>
            <label nz-radio-button nzValue="system">System</label>
        </nz-radio-group>
        <button
            nz-button
            nzType="primary"
            nzShape="round"
            (click)="openCreateActivity(ACTIVITY_TYPES.CALL)"
        >
            Log Activity
        </button>
    </div>
    <br />

    <p
        class="w-full border bg-slate-100 rounded-md p-6 text-center shadow-sm"
        *ngIf="displayedActivities?.length === 0"
    >
        No Activity Yet
    </p>
    <nz-timeline>
        <nz-timeline-item
            *ngFor="let activity of displayedActivities"
            [nzColor]="activityTypeMeta(activity.type).dot"
        >
            <div
                class="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
            >
                <!-- header -->
                <div class="w-full flex justify-between items-start gap-2">
                    <!-- type eyebrow -->
                    <span
                        class="inline-flex items-center gap-2 rounded-full px-2.5 py-1.5 text-[11px] font-medium uppercase tracking-wide leading-none"
                        [ngClass]="activityTypeMeta(activity.type).pill"
                    >
                        <i
                            *ngIf="activityTypeMeta(activity.type).icon"
                            [ngClass]="activityTypeMeta(activity.type).icon"
                            class="text-sm leading-none"
                        ></i>
                        <span
                            *ngIf="activityTypeMeta(activity.type).nzIcon"
                            nz-icon
                            [nzType]="activityTypeMeta(activity.type).nzIcon"
                            nzTheme="outline"
                            class="text-sm leading-none"
                            [class.-scale-x-100]="activity.type === ACTIVITY_TYPES.CALL"
                        ></span>
                        <span class="leading-none">{{
                            activityTypeMeta(activity.type).label
                        }}</span>
                    </span>

                    <!-- status / source tags -->
                    <div class="flex items-center flex-wrap justify-end gap-1.5">
                        <span
                            *ngIf="activity?.meta?.open"
                            class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-normal text-gray-900"
                        >
                            <span class="h-1.5 w-1.5 rounded-full bg-green-500"></span>
                            Open
                        </span>
                        <span
                            *ngIf="activity?.meta?.click"
                            class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-normal text-gray-900"
                        >
                            <span class="h-1.5 w-1.5 rounded-full bg-blue-500"></span>
                            Click
                        </span>
                        <span
                            *ngIf="activity?.meta?.unsubscribed"
                            class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-normal text-gray-900"
                        >
                            <span class="h-1.5 w-1.5 rounded-full bg-rose-500"></span>
                            Unsubscribe
                        </span>
                        <span
                            class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-normal text-gray-900"
                        >
                            <span
                                class="h-1.5 w-1.5 rounded-full"
                                [ngClass]="
                                    isWorkflowActivity(activity)
                                        ? 'bg-violet-500'
                                        : 'bg-slate-400'
                                "
                            ></span>
                            {{
                                isWorkflowActivity(activity)
                                    ? 'Workflow'
                                    : 'System'
                            }}
                        </span>
                    </div>
                </div>
                <!-- end header -->

                <!-- body -->
                <div *ngIf="activity.type === ACTIVITY_TYPES.CALL">
                    <p class="text-base font-normal text-gray-900">
                        Call lasted
                        <span class="font-medium">{{
                            activity?.meta?.callDuration
                                ? activity.meta.callDuration + ' mins'
                                : '-'
                        }}</span>
                        <span *ngIf="activity?.meta?.callOutcome">
                            <span class="px-1 text-gray-300">·</span>
                            result:
                            <span class="font-medium">{{
                                activity.meta.callOutcome
                            }}</span>
                        </span>
                    </p>
                </div>

                <div *ngIf="activity.type === ACTIVITY_TYPES.SMS">
                    <p class="text-base font-normal text-gray-900">
                        <span class="font-medium">Message:</span>
                        <span class="italic text-gray-600">{{
                            activity?.meta?.message
                        }}</span>
                    </p>
                </div>

                <div
                    *ngIf="activity.type === ACTIVITY_TYPES.GORGIAS"
                    class="flex flex-col gap-1.5"
                >
                    <span class="text-base font-medium text-gray-900">{{
                        activity?.meta?.subject
                    }}</span>
                    <div class="flex items-center flex-wrap gap-2">
                        <span
                            *ngIf="activity?.meta?.type"
                            class="rounded-md bg-rose-50 px-2 py-0.5 text-xs font-normal text-rose-600"
                            >{{ activity?.meta?.type }}</span
                        >
                        <a
                            *ngIf="activity?.meta?.url"
                            [href]="activity?.meta?.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 hover:underline"
                        >
                            {{ activity?.meta?.url }}
                            <i
                                class="fa-solid fa-up-right-from-square text-[10px]"
                            ></i>
                        </a>
                    </div>
                </div>

                <div
                    *ngIf="activity.type === ACTIVITY_TYPES.EMAIL"
                    class="flex flex-col gap-1"
                >
                    <div class="flex items-baseline flex-wrap gap-2">
                        <span class="text-base font-semibold text-gray-900">{{
                            activity?.meta?.subject
                        }}</span>
                        <span
                            *ngIf="activity?.meta?.template"
                            class="text-sm font-normal text-gray-400"
                            >template: {{ activity?.meta?.template }}</span
                        >
                    </div>
                    <p class="text-sm font-normal text-gray-400 truncate">
                        <span>{{ activity?.meta?.fromEmail }}</span>
                        <span class="px-1 text-gray-300">→</span>
                        <span>{{ formatTo(activity?.meta?.toEmail) }}</span>
                    </p>
                </div>

                <div *ngIf="activity.type === ACTIVITY_TYPES.OTHER">
                    <p class="text-base font-normal text-gray-900">{{ activity.label }}</p>
                </div>

                <p *ngIf="activity.note" class="text-sm font-normal text-gray-500">
                    <span class="font-medium text-gray-400">Admin note:</span>
                    {{ activity.note }}
                </p>
                <!-- end body -->

                <!-- footer -->
                <div
                    class="w-full flex items-center gap-2 border-t border-gray-100 pt-2 text-xs font-normal text-gray-400 min-w-0"
                >
                    <span
                        class="min-w-0 flex-1 truncate"
                        nz-tooltip
                        [nzTooltipTitle]="
                            (activity.createdAt | date: 'MMM d, yyyy h:mm a') +
                            ' by ' +
                            activity.createdBy.fullName
                        "
                    >
                        {{ activity.createdAt | date: 'MMM d, yyyy h:mm a' }} by
                        <span class="font-medium text-gray-600">{{
                            activity.createdBy.fullName
                        }}</span>
                    </span>
                    <span
                        *ngIf="activity.resourceType && activity.resourceId"
                        class="shrink-0 rounded-md border border-gray-200 bg-gray-50 px-2 py-0.5 font-mono text-[11px] text-gray-500"
                    >
                        {{ activity.resourceType }}s/{{ activity.resourceId }}
                    </span>
                </div>
                <!-- end footer -->
            </div>
        </nz-timeline-item>
    </nz-timeline>
</div>
